<!--
	// DROPDOWN //
		- a dropdown list with a main title and a series of buttons which optionally act as links or emit custom events

	// INPUTS //
		icon (string, optional):
			- file name of an svg icon stored in @/assets/img/icons/{icon}.svg
		title (string, required):
			- main text to be displayed next to the icon
		links (array, optional):
			- an array of objects containing titles and link paths, if a link path is not provided a custom event will be emitted on click
		invert (boolean, optional):
			- inverts the colours for display on dark backgrounds
		close (boolean, optional):
			- changing the value closes the dropdown

	// OUTPUTS //
		redirect:
			- when a link with a path is clicked, react router will navigate to it
		custom event:
			- when a link without a path is clicked, a custom event will be emitted (@{link.title}) which can be monitored in a parent component
		expand:
			- when the dropdown is expanded @expand will be emitted to the parent component
-->

<template>
	<div class="z-40 transition-all duration-200 bg-white overflow-hidden text-gray-800"
		:class=" openDropdown ? 'rounded-b-lg shadow-2xl' : 'rounded-b-lg border-0 shadow'"
		:style="dropdownStyle">

		<!-- title -->
		<div @click="expandDropdown($event)"
			class="flex items-center w-full justify-between select-none"
			:class="invert ? openDropdown ? 'bg-gray-800 bg-opacity-0 hover:bg-opacity-5' : 'bg-white bg-opacity-0 hover:bg-opacity-5' : 'bg-gray-800 bg-opacity-0 hover:bg-opacity-5'">
			
			<!-- icon & text -->
			<div class="pl-5 flex cursor-pointer bg-opacity-0 text-gray-800 py-4 w-full h-full">
				<LucideIcon name="CircleUser" :size="22" :stroke-width="1.8" color="#20283A" class=" self-center" />
				<h2 class="text-sm font-semibold w-auto pl-3 whitespace-nowrap self-center text-gray-800">{{title}}</h2>
			</div>

			<!-- chevron -->
			<div class="cursor-pointer bg-opacity-0 h-full text-gray-800">
				<div class="w-6 mx-4 py-3 transform transition-transform duration-200 self-center h-full"
					:class="openDropdown ? 'rotate-180' : 'rotate-0'">
					<LucideIcon name="ChevronDown" :size="22" :stroke-width="1.8" color="#20283A" class=" self-center" />
				</div>
			</div>	
		</div>

		<!-- links -->
		<div class="flex flex-col transform transition-transform duration-200 origin-top" :class="openDropdown ? 'scale-y-100 h-auto' : 'scale-y-0 h-0'" >
			<div @click="link.route ? navigateToLink(link.route) : handleClick($event, link)" v-for="link in linksList" :key="link.index" class="flex items-center hover:bg-gray-100 py-3 cursor-pointer h-12 pl-5">
				<LucideIcon :name="link.icon" :size="22" :stroke-width="1.8" color="#20283A" class=" self-center" />
				<p class="text-sm font-medium w-full pl-3 pr-8 text-gray-800">{{link.text}}</p>
			</div>
		</div>

	</div>
</template>

<script>

import LucideIcon from '@/components/LucideIcon';

export default {
    name: "DropDown",
    components: {
		LucideIcon
	},
    props: {
        icon: {
            type: String,
        },
        title: {
            type: String
        },
        links: {
            type: Array
        },
        invert: {
            type: Boolean,
            default: false
        },
		close: {
			type: Boolean,
			default: false
		}
    },
    data() {
        return {
            openDropdown: false,
            dropdownStyle: {
                height: '56px'
            }
        }  
    },
    methods: {
        expandDropdown() {
			this.$emit('expand');
            this.openDropdown = !this.openDropdown
        },
        navigateToLink(route) {
            this.$router.push(route)
        },
        handleClick(event, link) {
            this.$emit(link.title, event);
        }
    },
    computed: {
		linksList : function() {
				return this.links
		}
    },
    watch: {
        openDropdown: function(value) {
            const titleHeight = 56; // tailwind height x 4
            const linkHeight = 48; // tailwind height x 4

            if (value === true) {
                this.dropdownStyle.height = `${(this.linksList.length * linkHeight) + titleHeight}px`;
            } else {
                this.dropdownStyle.height = `${titleHeight}px`;
            }
        },
		close: function(value) {
			if (value === true) this.openDropdown = false;
			if (value === false) this.openDropdown = true;
		}
    }
}
</script>